// this file is used for controling the tour via iframe

import GlobalEvent from "js-events-listener";
// to use in App.jsx
if (typeof window !== "undefined") {
  window.GlobalEvent = GlobalEvent;
}

const EVENTS = {
  thumbnailPlayClick: "THUMBNAIL_PLAY_CLICK",
  startAutospin: "PLAYER_START_AUTO_SPIN",
  stopAutospin: "PLAYER_STOP_AUTO_SPIN",
  transitionTo: "PLAYER_TRANSITION_TO",
  transitionToImmediately: "PLAYER_TRANSITION_TO_IMMEDIATELY",
};

class EventTours {
  EVENTS = EVENTS;
  playerInstance;
  noInternalEmit = false;
  lockControl = false;
  didClickThumbnail = false;
  images = {};

  on(eventName, callback) {
    for (let supportedEvent in EVENTS) {
      if (eventName !== EVENTS[supportedEvent]) continue;
      GlobalEvent.on(EVENTS[supportedEvent], data => {
        typeof callback === "function" && callback(data);
      });
    }
  }

  internalEmit(eventName, data) {
    if (this.noInternalEmit) return;
    for (let supportedEvent in EVENTS) {
      if (eventName !== EVENTS[supportedEvent]) continue;
      GlobalEvent.emit(EVENTS[supportedEvent], data);
    }
  }

  attachPlayerListener = playerInstance => {
    if (
      Object.keys(playerInstance.config.images).length >
      Object.keys(this.images).length
    ) {
      this.playerInstance = playerInstance;
      this.images = Object.assign({}, this.playerInstance.config.images);
      this.playerInstance.controlsOrbit.isMainInstance = true;
    }
    const didClickThumbnail = () => this.didClickThumbnail;
    if (window.location.href.includes("sdk_enable=1")) {
      window.iframeControl = new IframeControl();
      if (
        document.querySelector("img[class^='splashPlay'][alt='Start tour!']")
      ) {
        document.querySelector(
          "img[class^='splashPlay'][alt='Start tour!']",
        ).onclick = function () {
          if (didClickThumbnail()) return;
          window.iframeControl._sendControlAction(EVENTS.thumbnailPlayClick);
        };
      }
    }
  };

  playerEmit(eventName, ...data) {
    if (eventName === "thumbnailPlayClick") {
      if (
        document.querySelector("img[class^='splashPlay'][alt='Start tour!']")
      ) {
        this.didClickThumbnail = true;
        document
          .querySelector("img[class^='splashPlay'][alt='Start tour!']")
          .click();
      }
      return;
    }
    if (!this.playerInstance) {
      console.log("you need to attach player listener");
      return;
    }
    this.noInternalEmit = true;
    for (let supportedEvent in EVENTS) {
      if (eventName !== supportedEvent) continue;
      if (
        eventName === "transitionTo" ||
        eventName === "transitionToImmediately"
      ) {
        if (
          Object.keys(this.playerInstance.config.images).length !==
          Object.keys(this.images).length
        ) {
          this.playerInstance.config.images = Object.assign({}, this.images);
        }
        GlobalEvent.emit("TOUR_PROGRAMATICALLY_TRANSITION");
      }
      this.playerInstance[eventName](...data);
    }
    this.noInternalEmit = false;
  }
}

const eventTours = new EventTours();

export default eventTours;

if (typeof window !== "undefined") {
  window.eventTours = eventTours;
}

class IframeControl {
  constructor() {
    this.init();
  }

  _sendControlAction(action, payload) {
    const data = {
      pathname: window.location.pathname,
      action: action,
      payload,
    };
    window.parent.postMessage(JSON.stringify(data), "*");
  }

  init() {
    window.addEventListener("message", function (event) {
      const { data } = event;
      try {
        const parsedData = JSON.parse(data);
        const pathname = window.location.pathname;
        if (
          !parsedData ||
          parsedData.pathname !== pathname ||
          !parsedData.action
        )
          return;
        const action = parsedData.action;
        const payload =
          typeof parsedData.payload === "undefined" ? [] : parsedData.payload;
        for (let key in EVENTS) {
          if (EVENTS[key] === action) {
            if (eventTours.lockControl) {
              eventTours.lockControl = false;
              eventTours.playerEmit(key, ...payload);
              eventTours.lockControl = true;
            } else {
              eventTours.playerEmit(key, ...payload);
            }
          }
        }
        if (action === "LOCK_CONTROL") {
          eventTours.lockControl = true;
          GlobalEvent.emit("LOCK_CONTROL");
          var overlay = document.createElement("div");
          overlay.className = "lock-control-overlay";
          overlay.setAttribute(
            "style",
            "position: fixed; z-index: 999999999999; top:0; left:0; right:0; bottom:0; background-color: transparent",
          );
          document.body.appendChild(overlay);
          document.querySelector(".lock-control-overlay").onclick = function (
            e,
          ) {
            !!e.stopPropagation && e.stopPropagation();
          };
        }
        if (action === "UNLOCK_CONTROL") {
          eventTours.lockControl = false;
          GlobalEvent.emit("UNLOCK_CONTROL");
          const lockOverlayDivs = document.querySelectorAll(
            ".lock-control-overlay",
          );
          if (lockOverlayDivs.length > 0) {
            lockOverlayDivs.forEach(lockOverlay => {
              lockOverlay.remove();
            });
          }
        }
        if (action === "ACTIVE_HOTSPOT_CHANGE") {
          GlobalEvent.emit("SET_ACTIVE_HOTSPOT", payload);
        }
        if (action === "VIEW_ANGLE_ROTATE_LEFT") {
          eventTours.lockControl = true;
          eventTours.playerInstance.controlsOrbit.rotateLeft(payload);
          eventTours.lockControl = false;
        }
        if (action === "VIEW_ANGLE_ROTATE_UP") {
          eventTours.lockControl = true;
          eventTours.playerInstance.controlsOrbit.rotateUp(payload);
          eventTours.lockControl = false;
        }
        if (action === "UPDATE_POSITION_ANGLE") {
          eventTours.lockControl = true;
          eventTours.playerInstance.controlsOrbit.updatePosition(payload);
          eventTours.playerInstance.disableHotspots = false;
          eventTours.lockControl = false;
        }
        if (action === "IMAGE_NAVIGATION_UPDATE_IMAGE_OPEN") {
          GlobalEvent.emit("INNER_IMAGE_NAVIGATION_UPDATE_IMAGE_OPEN", payload);
        }
        if (action === "UPDATE_IMAGE_NAVIGATION_SCROLL_POSITION") {
          GlobalEvent.emit(
            "INNER_UPDATE_IMAGE_NAVIGATION_SCROLL_POSITION",
            payload,
          );
        }
        if (action === "IMAGE_NAVIGATION_UPDATE_SELECTED_IMAGE") {
          GlobalEvent.emit(
            "INNER_IMAGE_NAVIGATION_UPDATE_SELECTED_IMAGE",
            payload,
          );
        }
        if (action === "BASE_HOTSPOT_HOVER") {
          if (payload.uuid) {
            const { innerWidth, innerHeight } = payload;
            if (!!innerWidth && !!innerHeight) {
              GlobalEvent.emit("BASE_HOTSPOT_HOVER_" + payload.uuid, {
                isHover: payload.isHover,
                clientX: (payload.clientX * window.innerWidth) / innerWidth,
                clientY: (payload.clientY * window.innerHeight) / innerHeight,
              });
            }
          }
        }
        if (action === "DECK_DROPDOWN_UPDATE") {
          GlobalEvent.emit("INNER_DECK_DROPDOWN_UPDATE", payload);
        }
        if (action === "SET_ACTIVE_POPUP") {
          GlobalEvent.emit("INNER_SET_ACTIVE_POPUP", payload);
        }
        if (action === "SET_INACTIVE_POPUP") {
          GlobalEvent.emit("INNER_SET_INACTIVE_POPUP");
        }
        if (action === "GENERAL_EVENT") {
          GlobalEvent.emit("INNER_GENERAL_EVENT", payload);
        }
      } catch (err) {
        console.log("event listener error", err);
      }
    });

    eventTours.on(EVENTS.startAutospin, data => {
      this._sendControlAction(EVENTS.startAutospin, data);
    });
    eventTours.on(EVENTS.stopAutospin, data => {
      this._sendControlAction(EVENTS.stopAutospin);
    });

    eventTours.on(EVENTS.transitionTo, data => {
      if (Array.isArray(data)) {
        // data = data.filter(val => typeof val === "string" && !isNaN(val));
        // console.log(data);
        const sendData = [data[0]];
        if (data[1] && data[1].position) {
          const { x, y, z } = data[1].position;
          sendData.push({ position: { x, y, z } });
        } else {
          sendData.push(undefined);
        }
        sendData.push(data[2]);
        sendData.push(data[3]);
        // console.log("EVENTS.transitionTo", sendData);
        this._sendControlAction(EVENTS.transitionTo, sendData);
      }
    });

    eventTours.on(EVENTS.transitionToImmediately, data => {
      console.log(data);
      if (Array.isArray(data)) {
        data = data.filter(val => typeof val === "string" && !isNaN(val));
      }
      this._sendControlAction(EVENTS.transitionToImmediately, data);
    });

    eventTours.on(EVENTS.setActivePopup, data => {
      console.log(data);
      this._sendControlAction(EVENTS.setActivePopup, data);
    });

    GlobalEvent.on("ACTIVE_HOTSPOT_CHANGE", data => {
      if (!eventTours.lockControl) {
        this._sendControlAction("SET_ACTIVE_HOTSPOT", data);
      }
    });

    GlobalEvent.on("VIEW_ANGLE_ROTATE_LEFT", data => {
      if (!eventTours.lockControl) {
        this._sendControlAction("VIEW_ANGLE_ROTATE_LEFT", data);
      }
    });
    GlobalEvent.on("VIEW_ANGLE_ROTATE_UP", data => {
      if (!eventTours.lockControl) {
        this._sendControlAction("VIEW_ANGLE_ROTATE_UP", data);
      }
    });
    GlobalEvent.on("UPDATE_POSITION_ANGLE", data => {
      if (!eventTours.lockControl) {
        this._sendControlAction("UPDATE_POSITION_ANGLE", data);
      }
    });
    GlobalEvent.on("REQUEST_SHARED_TOUR", () => {
      if (!eventTours.lockControl) {
        this._sendControlAction("REQUEST_SHARED_TOUR");
      }
    });
    GlobalEvent.on("IMAGE_NAVIGATION_UPDATE_IMAGE_OPEN", data => {
      if (!eventTours.lockControl) {
        this._sendControlAction("IMAGE_NAVIGATION_UPDATE_IMAGE_OPEN", data);
      }
    });
    GlobalEvent.on("UPDATE_IMAGE_NAVIGATION_SCROLL_POSITION", data => {
      if (!eventTours.lockControl) {
        this._sendControlAction(
          "UPDATE_IMAGE_NAVIGATION_SCROLL_POSITION",
          data,
        );
      }
    });
    GlobalEvent.on("IMAGE_NAVIGATION_UPDATE_SELECTED_IMAGE", data => {
      if (!eventTours.lockControl) {
        this._sendControlAction("IMAGE_NAVIGATION_UPDATE_SELECTED_IMAGE", data);
      }
    });
    GlobalEvent.on("BASE_HOTSPOT_HOVER", data => {
      if (!eventTours.lockControl) {
        this._sendControlAction("BASE_HOTSPOT_HOVER", data);
      }
    });
    GlobalEvent.on("DECK_DROPDOWN_UPDATE", data => {
      if (!eventTours.lockControl) {
        this._sendControlAction("DECK_DROPDOWN_UPDATE", data);
      }
    });
    GlobalEvent.on("SET_ACTIVE_POPUP", data => {
      if (!eventTours.lockControl) {
        const { uuid } = data._config;
        if (uuid) this._sendControlAction("SET_ACTIVE_POPUP", { uuid });
      }
    });
    GlobalEvent.on("SET_INACTIVE_POPUP", () => {
      console.log("here");
      if (!eventTours.lockControl) {
        this._sendControlAction("SET_INACTIVE_POPUP", {});
      }
    });
    GlobalEvent.on("GENERAL_EVENT", payload => {
      if (!eventTours.lockControl) {
        this._sendControlAction("GENERAL_EVENT", payload);
      }
    });
  }
}

// eventTours.on(EVENTS.startAutospin, (data) => {
//   console.log('startAutospin', data);
// })
// eventTours.on(EVENTS.stopAutospin, (data) => {
//   console.log('stopAutospin');
// })

// eventTours.on(EVENTS.transitionTo, (data) => {
//   console.log(data);
//   console.log('eventTours');
// })

// eventTours.on(EVENTS.transitionToImmediately, (data) => {
//   console.log(data);
// })

window.makeSharedEvent = (name, payload) => {
  if (!eventTours.lockControl) {
    GlobalEvent.emit("GENERAL_EVENT", { name, payload });
  }
};

window.useWithSharedEvent = (func, name) => {
  return function () {
    const fromEvent = !!arguments && arguments[1] === true;
    if (!eventTours.lockControl && !fromEvent) {
      GlobalEvent.emit("GENERAL_EVENT", {
        name,
        payload: !!arguments && !!arguments[0] ? arguments[0] : undefined,
      });
    }
    func(!!arguments && !!arguments[0] ? arguments[0] : undefined);
  };
};

let _timeout;
window.useWithSharedEventDebounce = (func, name, debounceMilisecs = 500) => {
  return function () {
    const fromEvent = !!arguments && arguments[1] === true;
    if (!eventTours.lockControl && !fromEvent) {
      if (_timeout) clearTimeout(_timeout);
      _timeout = setTimeout(() => {
        GlobalEvent.emit("GENERAL_EVENT", {
          name,
          payload: !!arguments && !!arguments[0] ? arguments[0] : undefined,
        });
      }, debounceMilisecs);
    }
    func(!!arguments && !!arguments[0] ? arguments[0] : undefined);
  };
};

window.onSharedEvent = (name, callback = () => {}) => {
  const id = GlobalEvent.on("INNER_GENERAL_EVENT", data => {
    console.log("INNER_GENERAL_EVENT", data);
    if (data.name === name) {
      callback(data.payload);
    }
  });
  return () => {
    GlobalEvent.rm(id);
  };
};
